import React from 'react';
import './ButtonList.scss';
import plusIcon from './images/plus-iconn.svg';
import Image from 'app/Components/Shared/Image/image';

const ButtonsList = ({links, actionCallback, containerWidth, itemsPerRow}) => {
  const determineHref = (link) => {
    if (actionCallback || link?.onClick) {
      return undefined;
    }

    return link?.href;
  };

  const handleClick = (event, link) => {
    event.stopPropagation();

    if (actionCallback) {
      event.preventDefault();
      actionCallback(link);
      return;
    }

    if (link?.onClick) {
      event.preventDefault();
      link.onClick(event);
    }
  };

  const hasItemsPerRow = Number.isFinite(Number(itemsPerRow)) && Number(itemsPerRow) > 1;
  const containerStyle = {
    ...(containerWidth ? {width: '100%', maxWidth: `${containerWidth}px`} : {width: '100%'}),
    ...(hasItemsPerRow ? {'--items-per-row': Number(itemsPerRow)} : {}),
  };

  const linksRows = hasItemsPerRow
    ? links.reduce((rows, link, index) => {
        const rowIndex = Math.floor(index / Number(itemsPerRow));
        if (!rows[rowIndex]) rows[rowIndex] = [];
        rows[rowIndex].push(link);
        return rows;
      }, [])
    : null;

  const renderButton = (link, index) => {
    const badgeStyle = link.badgeColor ? {backgroundColor: link.badgeColor} : {};
    const key = link?.idx ?? index;
    const isActionOnlyButton = Boolean(link?.onClick) && !link?.href;

    if (isActionOnlyButton) {
      return (
        <button key={key} type='button' onClick={(event) => handleClick(event, link)} className={`action-button ${link.isAllActionsButton ? 'all-actions-button' : ''}`}>
          <span className='button-title'>{link.title}</span>
          {link.showBadge && link.badgeTitle ? (
            <span className='button-badge' style={badgeStyle}>
              {link.badgeTitle}
            </span>
          ) : null}
          {link.isAllActionsButton && <Image  className='all-actions-icon' src={plusIcon} />}
        </button>
      );
    }

    return (
      <a
        key={key}
        href={determineHref(link)}
        onClick={actionCallback || link.onClick ? (event) => handleClick(event, link) : null}
        className={`action-button ${link.isAllActionsButton ? 'all-actions-button' : ''}`}>
        <span className='button-title'>{link.title}</span>
        {link.showBadge && link.badgeTitle ? (
          <span className='button-badge' style={badgeStyle}>
            {link.badgeTitle}
          </span>
        ) : null}
        {link.isAllActionsButton && <Image className='all-actions-icon' src={plusIcon} />}
      </a>
    );
  };

  return (
    <div className={`buttons-list-container ${hasItemsPerRow ? 'items-per-row-enabled' : ''}`} style={containerStyle}>
      {hasItemsPerRow
        ? linksRows.map((rowLinks, rowIndex) => (
            <div className='buttons-list-row' key={`row-${rowIndex}`}>
              {rowLinks.map((link, colIndex) => renderButton(link, rowIndex * Number(itemsPerRow || 1) + colIndex))}
            </div>
          ))
        : links.map((link, index) => renderButton(link, index))}
    </div>
  );
};

export default ButtonsList;

